// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"modalVideo-module--videoWrapper--2Sn_6","innerContainer":"modalVideo-module--innerContainer--3-bv_","closeButton":"modalVideo-module--closeButton--3TEi9"};